import { plainJottacloudTheme } from './jottacloud.theme.plain'
import './theme.css'
export const jottacloudtheme = plainJottacloudTheme
export default jottacloudtheme
